import React from 'react'
import PriceCard from './PriceCard'
import { Card, Checkbox, Col, Divider, Row, Tooltip } from 'antd';
import { FieldDivider } from 'components/fields';
import { InfoCircleOutlined } from "@ant-design/icons";
import CommonCard, { colCardStyle, contentAreaStyle, outerCardStyle } from './CommonCard';

function Sessions({ sessionData, packageData, selectedPackages, selectedSessions, setSelectedSessions,selectedAddOns, ...props }) {
  const sessions = sessionData || [];
  const packages = packageData || [];
  // All session IDs inside selected packages
  const disabledSessionIds = new Set(
    selectedPackages.flatMap((pkg) => pkg.sessions.map((s) => s.uuid))
  );


  const toggleSelect = (session) => {
    if (disabledSessionIds.has(session.uuid)) return;
    const exists = selectedSessions.some((s) => s.uuid === session.uuid);
    if (exists) {
      setSelectedSessions((prev) =>
        prev.filter((s) => s.uuid !== session.uuid)
      );
    } else {
      setSelectedSessions((prev) => [...prev, session]);
    }
  };
  return (
     <div style={outerCardStyle}>
      <div style={contentAreaStyle}>
        <Row gutter={[16, 16]} wrap>
          {sessions?.map((session) => {
            const isSelected = selectedSessions?.some((s) => s.uuid === session.uuid);
            const isDisabled = disabledSessionIds.has(session.uuid);
            return (
              <Col xs={24} sm={24} md={24} lg={6} xl={6} key={session.uuid} style={colCardStyle}>
                <CommonCard
                  data={session}
                  isSelected={isSelected}
                  toggleSelect={toggleSelect}
                  isDisabled={isDisabled}
                  modelName="session"
                >
                </CommonCard>
              </Col>
            );
          })}
        </Row>
      </div>
      <div style={{ textAlign: 'left', alignSelf: 'flex-start', marginTop: 3 }}>
        <PriceCard sessions={selectedSessions} packages={selectedPackages} addons={selectedAddOns} />
      </div>
    </div>
  )
}

export default Sessions